import React from 'react';
import { FormControl, FormHelperText, InputAdornment, MenuItem } from '@mui/material';
import { IMaskInput } from 'react-imask';
import { InputOptions } from '../../../features/payment/interfaces';
import { InputTypes } from '../../../constants';
import { Select } from '../select';
import { TextField } from '../text-field';
import { InputLabel } from '../input-label';

interface FieldProps {
  id: string;
  type: InputTypes;
  name: string;
  label: string;
  value?: string;
  placeholder?: string;
  prefix?: string;
  mask?: string;
  disabled?: boolean;
  options?: InputOptions[];
  error?: string;
  onChange: (event: object) => void;
  onBlur?: (event: object) => void;
}

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  mask: string;
}

const TextMaskCustom = React.forwardRef<HTMLElement, CustomProps>((props, ref) => {
  const { onChange, mask, name, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask={mask}
      definitions={{
        '9': /[0-9]/,
      }}
      onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

const Field = ({
  id,
  type,
  name,
  label,
  value,
  placeholder,
  prefix,
  mask,
  disabled,
  options,
  error,
  onChange,
  onBlur,
}: FieldProps) => {
  return (
    <div>
      {InputTypes.COMBO_BOX === type ? (
        <FormControl translate="no" fullWidth error={!!error} disabled={disabled}>
          <InputLabel error={!!error} disabled={disabled}>
            {label}
          </InputLabel>
          <Select id={id} label={label} displayEmpty name={name} value={value} onChange={onChange} onBlur={onBlur}>
            <MenuItem disabled value="">
              <em>{placeholder}</em>
            </MenuItem>
            {options?.map((op, idx) => (
              <MenuItem key={idx} value={op.value}>
                {op.displayName}
              </MenuItem>
            ))}
          </Select>
          {error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
      ) : (
        <TextField
          id={id}
          translate="no"
          label={label}
          name={name}
          value={value}
          placeholder={mask?.replace(/9/gi, ' _ ') || placeholder}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          InputProps={{
            inputProps: {
              name,
              mask,
            },
            inputComponent: mask && (TextMaskCustom as any),
            startAdornment: prefix && <InputAdornment position="start">{prefix}</InputAdornment>,
          }}
          error={!!error}
          helperText={error}
          fullWidth
        />
      )}
    </div>
  );
};

export default Field;
